<section class="h-full flex flex-col">
  <app-modal-header title="AI Code Assist" (onClose)="cancel()" [save]="code.length > 0" [processing]="loading"
                    (onSave)="useCode()"></app-modal-header>

  <mat-dialog-content>
    <div class="dm-input mb-3">
      <label>{{ hasCode ? 'What would you like to change?' : 'Describe what this code should do (include the expected output)' }}</label>
      <textarea rows="4" [formControl]="descriptionControl" [autofocus]="true"></textarea>
    </div>

    <div class="flex justify-between items-center mb-4">
      <button class="btn btn-sm btn-flat" *ngIf="hasCode" [disabled]="loading" (click)="startOver()">
        <i class="fas fa-rotate-left mr-1"></i>
        Start over
      </button>
      <span *ngIf="!hasCode"></span>
      <button class="btn btn-sm btn-primary" [disabled]="loading" (click)="submit()">
        <i class="fas fa-circle-notch fa-spin mr-1" *ngIf="loading"></i>
        {{ hasCode ? 'Update code' : 'Generate code' }}
      </button>
    </div>

    <p class="p-3 bg-red-50 rounded-control text-gray-800 mb-3" *ngIf="error">
      <i class="fas fa-exclamation-triangle mr-1 text-red-600"></i>
      {{ error }}
    </p>

    <div *ngIf="code">
      <label class="text-sm text-gray-500">Code preview</label>
      <pre class="ai-code-preview">{{ code }}</pre>
    </div>

    <div *ngIf="history.length" class="mt-3">
      <label class="text-sm text-gray-500">History</label>
      <ul class="text-xs text-gray-600">
        <li *ngFor="let entry of history" class="mb-1">{{ entry.request }}</li>
      </ul>
    </div>
  </mat-dialog-content>
</section>
